import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, MeasurementUnitCodesEnum, SetInitialStateFacade } from '../../../../../common/models';
import {
  ShipmentTransportOrderOuterPackagesListInitialState,
  ShipmentTransportOrderOuterPackagesListLoad,
} from './shipment-transport-order-outer-packages.actions';
import {
  ShipmentTransportOrderOuterPackagesListStateModel,
  ShipmentTransportOrderOuterPackagesState,
} from './shipment-transport-order-outer-packages.state';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderOuterPackagesFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ShipmentTransportOrderOuterPackagesListStateModel> = this.store.select(
    ShipmentTransportOrderOuterPackagesState.getState,
  );
  dimensionsUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderOuterPackagesState.getDimensionsUnitCode,
  );
  weightUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderOuterPackagesState.getWeightUnitCode,
  );
  volumeUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderOuterPackagesState.getVolumeUnitCode,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderOuterPackagesState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportOrderIdView: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderOuterPackagesListLoad(transportOrderIdView));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderOuterPackagesListInitialState());
  }
}
